<template>
  <div class="order_detail_all">
    <div class="nav_bar_box" :class="{ isiOSX: isiOSX }">
      <van-row class="nav_bar">
        <van-col span="9" @click="reBack()">
          <van-icon name="arrow-left" class="back_icon" />
        </van-col>
        <van-col span="6" class="nav-title">更多详情</van-col>

        <van-col class="tel_col sca09">
          <a href="tel:4000571671" @click="iOStel('4000571671')">
            <div class="img-box">
              <img
                class="nav_img mar_le15"
                src="../../../assets/hotel/img/order/detail_tel.png"
              />
            </div>
            <p class="tel_center">客服电话</p>
          </a>
        </van-col>
        <van-col class="hel_col sca09" @click="handleCustomerService()">
          <div class="img-box">
            <img
              class="nav_img"
              src="../../../assets/hotel/img/order/detail_help.png"
            />
          </div>
          <p class="tel_center">帮助</p>
        </van-col>
      </van-row>
    </div>
    <div class="order_detail_Body">
      <div class="order_detail_div" :class="{ isiOSX: isiOSX }">
        <div class="hint_time">
          <div>
            北京时间{{ dataSource.can_cancel_time }}前可免费取消此订单，
            逾期无法取消或退款。
          </div>
        </div>
        <p class="od_order_sn">
          您的订单号为&nbsp;{{ dataSource && dataSource.order_sn }}
        </p>
        <p class="info_title">酒店信息</p>
        <van-row>
          <van-col span="8" class="info_left_99">酒店名称</van-col>
          <van-col span="16" class="info_right">{{
            info && info.hotel_name
          }}</van-col>
        </van-row>
        <van-row>
          <van-col span="8" class="info_left_99">酒店英文</van-col>
          <van-col span="16" class="info_right">{{
           info && info.english_name
          }}</van-col>
        </van-row>
        <van-row>
          <van-col span="8" class="info_left_99">酒店地址</van-col>
          <van-col span="16" class="info_right"
            >&nbsp;{{ info && info.address }}</van-col
          >
        </van-row>
        <p class="info_title">入住信息</p>
        <van-row>
          <van-col span="8" class="info_left_99">入住时间</van-col>
          <van-col span="16" class="info_right">
            {{ dataSource.arrival_date
          }}<span class="or_de_day_number">{{ dataSource.day_number }}晚</span
          >{{ dataSource.departure_date }}
          </van-col>
        </van-row>
        <van-row>
          <van-col span="8" class="info_left_99">房间及间数</van-col>
          <van-col span="16" class="info_right"
            >{{ info.room_name }}，{{ dataSource.room_number }}间</van-col
          >
        </van-row>
        <van-row>
          <van-col span="8" class="info_left_99">床型</van-col>
          <van-col span="16" class="info_right">{{ info && info.bed }}</van-col>
        </van-row>
        <van-row>
          <van-col span="8" class="info_left_99">每间入住人数</van-col>
          <van-col span="16" class="info_right"
            >{{ dataSource.people_number }}人</van-col
          >
        </van-row>
        <van-row>
          <van-col span="8" class="info_left_99">入住人</van-col>
          <van-col span="16" class="info_right"
            ><span
              v-for="(item, index) in customer_person"
              :key="index"
              class="or_de_co_33"
            >
              {{ item.Name }}
            </span></van-col
          >
        </van-row>
        <p class="info_title">客房政策</p>
        <van-row>
          <van-col span="8" class="info_left_99">餐食</van-col>
          <van-col span="16" class="info_right">{{
            info.breakfast ? info.breakfast : "不含餐"
          }}</van-col>
        </van-row>
        <div>
          <p class="info_title">入住偏好</p>
          <van-row>
            <van-col span="8" class="info_left_99">预计到店时间</van-col>
            <van-col span="16" class="info_right">{{
              customer_arrive_date || "14:00"
            }}</van-col>
          </van-row>
          <van-row v-if="info.remark">
            <van-col span="8" class="info_left_99">其他的要求</van-col>
            <van-col span="16" class="info_right"
              ><span>{{ info.remark }}</span></van-col
            >
          </van-row>
        </div>
        <p class="info_title">发票&nbsp;/&nbsp;收据</p>
        <p class="hint_receipt">
          此订单发票/收据由酒店前台开具，请在入住完成 后向酒店前台索取。
        </p>
        <p class="info_title">价格明细</p>
        <van-row class="room_detail">
          <van-col span="18" class="home_info"
            >{{ dataSource.room_number + "间"
            }}{{ info.room_name }}&nbsp;&nbsp;x&nbsp;
            {{ dataSource.day_number }}晚</van-col
          >
          <van-col span="6" class="info_title marg_bot1 te_ri"
            >¥{{ dataSource && dataSource.order_money && dataSource.order_money.toFixed(2) }}</van-col
          >
        </van-row>
        <van-row :class="index===dataSource.price_detail.length-1 ? 'lastPriceDetail' :'priceDetail'" v-for="(item,index) in dataSource.price_detail" :key="index">
           <van-col span="12" class="meals">{{item.time}}&nbsp;{{index===0? '无餐食' : info.breakfast!=="无餐食"?info.breakfast+`${'&nbsp;'}/${'&nbsp;'}间`:info.breakfast || '无餐食'}}</van-col>
           <van-col span="12" class="price te_ri"> {{index===dataSource.price_detail.length-1 ? '' :   `1晚 ${'&nbsp;'}x ${'&nbsp;'}¥${item.dailyPrice}`}}</van-col>
        </van-row>
        <van-row class="red_packet">
          <van-col span="12">红包抵扣</van-col>
          <van-col span="12" class="tr_ri"
            >-&nbsp;¥{{
              dataSource.deduct_coin ? dataSource.deduct_coin.toFixed(2) : 0+'.00'
            }}</van-col
          >
        </van-row>
        <van-row class="pay">
          <van-col span="12" class="info_left_99">{{dataSource.status == 10 ? '需支付' : '在线支付'}}</van-col>
          <van-col span="12" class="money">¥{{dataSource &&  dataSource.pay_money && dataSource.pay_money.toFixed(2) }}</van-col>
        </van-row>
      </div>
      <div class="pre_body">
        <van-row
          class="pre_div reserve"
          v-if="
            dataSource.is_after_sales === 40 ||
              dataSource.is_after_sales == 30 ||
              dataSource.is_after_sales === 20 ||
              dataSource.is_after_sales === 10 ||
              dataSource.status == -10 ||
              dataSource.status == -20 ||
              dataSource.status == 50 ||
              dataSource.status == 25 ||
              dataSource.status == 20 ||
              dataSource.status == 30 ||
              (dataSource.status === 40 &&
                dataSource.return_credits_status == 2)
          "
        >
          <van-col span="24">
            <van-button
              @click="handleReserve()"
              type="default"
              class="submit_btn"
              >再次预订</van-button
            >
          </van-col>
        </van-row>
        <van-row
          class="pre_div"
          v-else-if="
            dataSource.status === 10 ||
              (dataSource.status === 40 &&
                dataSource.return_credits_status == 1)
          "
        >
          <van-col span="11">
            <van-button
              type="default"
              class="can_btn"
              @click="
                dataSource.status === 10 ? handleCancel() : handleReserve()
              "
              >{{
                dataSource.status === 10 ? "取消订单" : "再次预订"
              }}</van-button
            >
          </van-col>
          <van-col span="2"></van-col>
          <van-col span="11">
            <van-button
              type="default"
              :class="[
                dataSource.status === 10 ? 'submit_btn' : 'get_integral',
              ]"
              @click="
                dataSource.status === 10 ? handleToPay() : handleGetCredits()
              "
              >{{
                dataSource.status === 10 ? "去支付" : "领取积分"
              }}</van-button
            >
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="order-detail-loading" v-if="loading1">
      <img src="../../../assets/common/loading.gif" />
    </div>
  </div>
</template>

<script>
import "@/assets/hotel/css/reset.css";
import dsbridge from "dsbridge";
import { getCredits, getOrderDetail, getPayment } from "@/pages/hotel/api";
export default {
  data() {
    return {
      dataSource: {},
      info: {},
      customer_person: [],
      customer_arrive_date: "",
      id: this.$route.query.order_sn,
      facility: "",
      loading1: false,
    };
  },
  created() {
    this.isiOSX = this.isIphoneX();
    if (this.$route.query.token) {
      this.$api.setToken(this.$route.query.token);
    }

    this.onLoad();
  },
  mounted() {
    window.setPay = this.setPay;
    this.deductionUA();
  },
  methods: {
    setPay(v) {
      let data = JSON.parse(v);
      if (data.code == 0) {
        this.$toast("支付成功");
        this.loading1 = true;
        let countLimit1 = 0;
        const intervalId1 = setInterval(() => {
          countLimit1++;
          if (this.dataSource.status === 20) {
            clearInterval(intervalId1);
            this.loading1 = false;
            return;
          }
          this.onLoad();
          if (countLimit1 >= 5) {
            clearInterval(intervalId1);
            this.loading1 = false;
          }
        }, 1000);
      } else {
        this.$toast("支付失败");
      }
    },
    deductionUA() {
      const ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod/.test(ua)) {
        this.facility = "ios";
      } else if (/android/.test(ua)) {
        this.facility = "android";
      }
    },
    onLoad() {
      getOrderDetail({
        order_sn: this.id,
      })
        .then((data) => {
          this.dataSource = data;
          const { info, contact_phone, customer_arrive_date,price_detail } = data;
          const { customer_person } = info;
          price_detail.push({dailyPrice:'',time:this.getNextDate(price_detail[price_detail.length-1].time,1)});
          let index = customer_arrive_date.lastIndexOf(" ");
          this.customer_arrive_date = customer_arrive_date.substring(
            index + 1,
            customer_arrive_date.length - 3
          );
          this.customer_person = customer_person || [];
          this.info = info;
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    getNextDate(date, day) { 
    　　let dd = new Date(date);
    　　dd.setDate(dd.getDate() + day);
    　　let y = dd.getFullYear();
    　　let m = dd.getMonth() + 1 < 10 ? "0" + (dd.getMonth() + 1) : dd.getMonth() + 1;
    　　let d = dd.getDate() < 10 ? "0" + dd.getDate() : dd.getDate();
    　　return y + "-" + m + "-" + d;
    },
    handleCancel() {
      this.$router.push({
        path: "/hotel/cancelOrder",
        query: {
          order_sn: this.id || this.dataSource.order_sn,
          routing: "detail",
        },
      });
    },
    handleReserve() {
      this.$router.push({
        path: "/hotel/detail",
        query: {
          hotel_id: this.info.hotel_id,
          back: "order",
        },
      });
    },
    handleToPay() {
      getPayment({ order_sn: this.dataSource.order_sn })
        .then((res) => {
          //支付金额订单红包折扣订单编号订单类型
          const param = {
            actual_amount: this.dataSource.pay_money,
            order_amount: this.dataSource.order_money,
            ordersn: this.dataSource.order_sn,
            order_type: "hotelv2",
          };
          if (this.facility == "ios") {
            let that = this;
            dsbridge.call("goPay", JSON.stringify(param), function(v) {
              that.setPay(v);
            });
          } else if (this.facility == "android") {
            this.params(JSON.stringify(param), JSON.stringify(param), "goPay");
          }
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    handleGetCredits() {
      getCredits({
        order_sn: this.id || this.dataSource.order_sn,
      })
        .then((res) => {
          this.$toast("您已成功领取积分~");
          this.onLoad();
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          this.$toast(message);
        });
    },
    reBack() {
      if(this.$route.query.routing){
        this.$router.go(-3);
      }else{
        this.$router.go(-1);
      }
    },
    //帮助
    handleCustomerService() {
      this.params("6", "6", "customerService");
    },
    iOStel(phoneString) {
      let ua = navigator.userAgent.toLowerCase();
      if (/iphone|ipad|ipod|macintosh/i.test(ua) && !this.$route.query.from) {
        this.phone(phoneString);
      }
    },
    phone(phoneString) {
      this.tel = phoneString;
      this.params(this.tel, this.tel, "phone");
    },
  },
};
</script>

<style lang="less">
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
.order_detail_all {
    // font-weight:600;
    background: #fbfbfb;
  .nav_bar {
    width: calc(100% - 20px);
    margin: 0 auto;
    color: #333;
  }
  .help_title,
  .tel_title {
    font-size: 1.2rem;
    transform: scale(0.8);
    display: inline-block;
  }
  .nav-title {
    text-align: center;
    line-height: 4.4rem;
    font-size: 1.6rem;
    color: #333333;
  }
  .back_icon {
    font-size: 2rem;
    margin-top: 1.2rem;
  }
  .nav_bar_box {
    height: 4.4rem;
    padding-top: 4.4rem;
    position: fixed;
    width: 100%;
    z-index: 9999999;
    top: 0;
    box-shadow: 0 0.1rem 1rem #ddd;
    background: #fff;
  }
  .nav_img {
    width: 1.6rem;
    height: 1.6rem;
  }
  .hel_col {
    float: right;
    margin-right: 0.6rem;
  }
  .hel_col img {
    width: 1.6rem;
    height: 1.6rem;
    margin-top: 0.5rem;
    margin-left: 0.5rem;
  }
  .tel_center {
    text-align: center;
  }
  .tel_col {
    float: right;
  }
  .tel_col img {
    margin-left: 2.4rem;
  }
  .tel_col span {
    margin-left: 1rem;
  }
  .nav_img {
    width: 1.6rem;
    height: 1.6rem;
  }
  .img-box {
    width: 100%;
    text-align: center;
  }
  .img-box img {
    margin: 0.5rem auto 0 !important;
  }

  .mar_le15 {
    // margin-left: 15rem;
  }
  .sca09 {
    font-size: 1.2rem;
    transform: scale(0.9);
    display: inline-block;
  }
  .order_detail_Body {
    padding-top: 4.4rem;
    .order_detail_div {
      width: calc(100% - 2rem);
      margin: 2rem auto;
      padding-top: 4.4rem;
    }
    .hint_time {
      border-radius: 1rem;
      padding: 1rem;
      border: 1px solid #108b30;
      background: #ecf6ef;
      color: #108b30;
      font-size: 1.4rem;
      margin-bottom: 2rem;
      font-weight: 400;
    }
    .od_order_sn {
      font-size: 1.4rem;
      color: #333333;
      margin-bottom: 3rem;
      font-weight: 400;
    }
    .info_title {
      color: #333333;
      font-size: 1.7rem;
      font-weight: 600;
      margin-bottom: 2rem;
    }
    .room_detail{
      position: relative;
      .info_title{
          position: absolute;
          right: 0;
          bottom: 0;
          margin: 0;
      }
    }
    .priceDetail{
      color: #999;
      font-size: 1.3rem;
      margin: .5rem 0;
    }
    .lastPriceDetail{
        color: #999;
      font-size: 1.3rem;
      margin: .5rem 0 2rem;
    }
    .marg_bot1{
       margin-bottom: 1rem;
    }
    .info_left_99 {
      color: #999999;
      font-size: 1.6rem;
      margin-bottom: 2rem;
    }
    .info_right {
      font-size: 1.6rem;
      color: #333;
    }
    .or_de_day_number {
      color: #999999;
      font-size: 1.3rem;
      margin: 0 0.6rem;
    }
    .hint_receipt {
      color: #666666;
      font-size: 1.6rem;
      margin-bottom: 2rem;
    }
    .home_info {
      color: #666666;
      font-size: 1.6rem;
    }
    .mabo30 {
      margin-bottom: 3rem;
    }
    .red_packet {
      color: #f9591b;
      font-size: 1.6rem;
      margin-bottom: 2rem;
    }
    .tr_ri {
      text-align: right;
    }
    .pay {
      font-size: 1.6rem;
      color: #666666;
      padding-bottom: 12rem;
      .money {
        text-align: right;
        color: #f84737;
        font-size: 1.6rem;
        font-weight: 600;
      }
    }
    .te_ri {
      text-align: right;
    }
  }
  .pre_body {
    position: fixed;
    bottom: 0;
    padding: 1.5rem 0 2.7rem;
    width: 100%;
    background: #fff;
    box-shadow: 0 0.2rem 1.7rem #bfbfbf;
  }
  .pre_div {
    width: calc(100% - 20px);
    margin: 0 auto;
  }
  .can_btn {
    height: 4rem;
    width: 100%;
    line-height: 4rem;
    border-radius: 2rem;
    font-size: 1.6rem;
    border: 1px solid #333;
  }
  .submit_btn {
    height: 4rem;
    width: 100%;
    line-height: 4rem;
    border-radius: 2rem;
    color: #fff;
    background-image: linear-gradient(to right, #0fbf6d, #108b30);
    font-size: 1.6rem;
    border:none;
    font-weight: 600;
  }
  .get_integral {
    height: 4rem;
    width: 100%;
    line-height: 4rem;
    border-radius: 2rem;
    color: #fff;
    background-image: linear-gradient(to right, #ff7742, #ff5a4b);
    font-size: 1.6rem;
  }
  .reserve {
    width: calc(100% - 2rem);
    margin: 0 auto;
  }
}

.isiOSX {
  padding-top: 44px;
}
.order-detail-loading {
  text-align: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  img {
    width: 35%;
    margin-top: 65%;
  }
}
</style>
